import { apiSlice } from "../apiSlice";
import { CreateOrderData } from "./orderService";

export interface CartItemRequest {
  id: string;
  cart?: {
    id: string;
    displayName: string;
  };
  restaurantId: string;
  orderItems: Array<{
    displayName: string;
    menuItemId: string;
    quantity: number;
    unitPrice: number;
    itemType: string;
    portionSize: string;
  }>;
  createdAt: {
    _seconds: number;
    _nanoseconds: number;
  };
  orders?: Array<{
    toCartId: string;
    orderId: string;
    fromCartId?: string;
  }>;
  status?: string;
}

export interface OrderDetails {
  id: string;
  orderReference: string;
  orderStatus: string;
  totalPrice: number;
  displayName: string;
  paymentMethod: string;
  isDeliveryOrder: boolean;
  orderItems: Array<{
    menuItemId: string;
    displayName: string;
    itemType: string;
    quantity: number;
    unitPrice: number;
  }>;
  createdAt: {
    _seconds: number;
    _nanoseconds: number;
  };
  paymentSummary?: {
    totalPrice: number;
    netAmount: number;
    cashPaymentAmount: number;
    cardPaymentAmount: number;
    walletPaymentAmount: number;
    deliveryFee: number;
    cartCommission: number;
  };
  cart?: {
    cartId: string;
    displayName: string;
    cartPersonId: string;
    userId: string;
  };
}

export interface GetCartItemRequestsResponse {
  items: CartItemRequest[];
}

export interface GetCartItemRequestByIdResponse {
  itemRequest: {
    request: CartItemRequest;
    orderDetails?: OrderDetails[];
  };
}

export interface CreateCartToCartOrderRequest {
  sourceOrder: CreateOrderData;
  destinationOrder: CreateOrderData;
}

const API_BASE_DOMAIN = process.env.REACT_APP_API_BASE_DOMAIN_PROD;

export const cartToCartService = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getCartItemRequests: builder.query<GetCartItemRequestsResponse, { restaurantId: string; startDate: string }>({
      query: ({ restaurantId, startDate }) => {
        const encodedRestaurantId = encodeURIComponent(restaurantId);
        return `https://adminhttps-getcartitemrequestlist${API_BASE_DOMAIN}/?restaurantId=${encodedRestaurantId}&startDate=${startDate}`;
      },
    }),
    getCartItemRequestById: builder.query<GetCartItemRequestByIdResponse, string>({
      query: (requestId) => {
        return `https://adminhttps-getcartitemrequestbyid${API_BASE_DOMAIN}/?requestId=${requestId}`;
      },
    }),
    updateCartItemRequestStatus: builder.mutation<string, { requestId: string; status: string }>({
      query: ({ requestId, status }) => {
        return {
          url: `https://adminhttps-cancelcartitemrequest${API_BASE_DOMAIN}/?cartItemRequestId=${requestId}&status=${status}`,
          method: 'PUT',
        };
      },
    }),
    createCarttoCartOrder: builder.mutation<any, CreateCartToCartOrderRequest>({
      query: (data) => {
        return {
          url: `https://adminhttps-createcarttocartorder${API_BASE_DOMAIN}`,
          method: 'POST',
          body: data,
          responseHandler: (response) => response.json(),
        };
      },
    }),
  }),
});

export const {
  useLazyGetCartItemRequestsQuery,
  useLazyGetCartItemRequestByIdQuery,
  useUpdateCartItemRequestStatusMutation,
  useCreateCarttoCartOrderMutation,
} = cartToCartService;